import { render } from "./PaymentTransactionCreate.vue?vue&type=template&id=1c3e683c"
import script from "./PaymentTransactionCreate.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__